// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"PageLoader_pageLoader__3RgQ3","appLoading":"PageLoader_appLoading__DCA-N"};